import React, { memo } from 'react';
import clsx from 'clsx';
import useStyles from '../styles/iconStyle';

interface Props {
    className?: string;
    id: string;
    children: any;
    width?: number | string;
    height?: number | string;
    viewBox?: string;
    mdIcon?: boolean;
}

const SvgIcon = memo(({ className, width, height, viewBox, mdIcon, ...rest }: Props) => {
    const classes = useStyles();

    return (
        <svg
            className={clsx(classes.root, className)}
            width={width ? width : mdIcon ? 32 : 24}
            height={height ? height : mdIcon ? 32 : 24}
            viewBox={viewBox || '0 0 24 24'}
            {...rest}
        />
    );
});

export default SvgIcon;
